module.exports = __webpack_public_path__ + "assets/arabic.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/arabic.png
 ** module id = 202
 ** module chunks = 1
 **/